import OrtTypeIcon from "./OrtTypeIcon";

export default function OrtFilterRemoveButton({item, group, filters, setFilters}) {
    const newFilters = filters[group].filter(value => value !== item);
    return <button className="baukultur-map__filter-remove-button" onClick={() => setFilters({...filters, [group]: newFilters})} title="Filter entfernen">
        <img className="baukultur-map__filter-remove-button-x" src={`${baukulturMap.pluginUrl}img/icon/close-x.svg`} alt="Remove filter"/>
        <span className="baukultur-map__filter-remove-button-label">{item}</span>
        <OrtTypeIcon ortType={item} />
    </button>
}